import type { GetAccountResponse } from 'backend/types'
import { apiFetch } from '..'

/**
 * ログイン中のアカウント情報を取得する
 *
 * @returns アカウント情報
 */
export async function getAccount(): Promise<GetAccountResponse> {
  return apiFetch<GetAccountResponse>('/api/account', { method: 'GET' })
}

/**
 * パスワード変更API
 *
 * @param oldPassword - 旧パスワード
 * @param newPassword - 新パスワード
 * @throws ApiError - 認証失敗（400: パスワード不一致）、アカウント未発見（404）
 */
export async function changePassword(oldPassword: string, newPassword: string): Promise<void> {
  await apiFetch<void>('/api/account/password', {
    method: 'PUT',
    body: JSON.stringify({ oldPassword, newPassword }),
  })
}
